import { useEffect, useState } from "react";
import { getStoreConfig } from "../../../../config/Services";

// Keep this check local to the mounted screen; do not cache store configuration.
const useKdsAvailability = (shouldCheck = true) => {
  const locId = localStorage.getItem("locId");
  const [availability, setAvailability] = useState({ loading: true, enabled: false, error: false });

  useEffect(() => {
    if (!shouldCheck) return;
    let cancelled = false;
    setAvailability({ loading: true, enabled: false, error: false });

    const checkAvailability = async () => {
      try {
        if (!locId) throw new Error("Missing location");
        const response = await getStoreConfig(locId);
        const configurations = response?.data?.storeConfig?.configurationDetails;
        if (response?.data?.es > 0 || !Array.isArray(configurations)) {
          throw new Error("Unable to load configuration");
        }
        const displayMode = configurations.find((item) => item.key === "DISPLAY_SYSTEM_MODE");
        const enabled = !!displayMode?.storeConfigSettings?.kdsDisplayScreens?.includes("KDS");
        if (!cancelled) setAvailability({ loading: false, enabled, error: false });
      } catch {
        if (!cancelled) setAvailability({ loading: false, enabled: false, error: true });
      }
    };

    checkAvailability();
    return () => { cancelled = true; };
  }, [locId, shouldCheck]);

  return availability;
};

export default useKdsAvailability;
